import "core-js/modules/es.array.unshift.js";
const confetti = require("@assets/js/confetti.js");
export default {
  name: "popNftShards",
  props: {
    detail: null
  },
  computed: {
    confetti() {
      return confetti;
    }
  },
  data() {
    return {
      animateStart: false,
      animateEle: false,
      showEle: false,
      isNftUrlLLoad: false
    };
  },
  watch: {
    detail: {
      handler(obj) {
        if (obj && obj.type === "compose" && obj.image_url) {
          this.resetAnimation();
        }
      },
      immediate: true,
      deep: true
    },
    "$parent.popNftDetailShow": {
      handler(bool) {
        if (!bool) {
          this.resetAnimation();
          this.$parent.iscraftLoading = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setConfetti() {
      this.confetti({
        particleCount: 20,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        }
      });
      this.confetti({
        particleCount: 20,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        }
      });
    },
    resetAnimation() {
      // Reset states and wait for image load
      this.animateStart = false;
      this.animateEle = false;
      this.showEle = false;
      this.isNftUrlLLoad = false;
    },
    async onImageLoad() {
      if (this.detail.type != "compose") {
        this.$parent.iscraftLoading = false;
        return;
      }
      this.isNftUrlLLoad = true;
      // Step 1: 播放 image 动画
      this.animateStart = true;
      await new Promise(resolve => setTimeout(resolve, 1500));
      // Step 2: 延迟显示元素部分
      this.showEle = true;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.setConfetti();
      this.animateEle = true;
      this.$parent.iscraftLoading = false;
      this.$parent.myNFTList.unshift(this.detail);
    },
    onImageError(err) {
      console.log("errrrrrrrrr", err);
    }
  }
};